import { useEffect } from 'react';
import LeadMagnetForm from './LeadMagnetForm';

interface LeadMagnetModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

// ----------------------------------------------------------------------------
// Единственное модальное окно лид-магнита на весь сайт.
// Используется и compact-блоком, и хиро-тизером — форма внутри одна и та же.
// Закрытие по Escape, клику вне окна и по крестику; фон блокируется от скролла.
// ----------------------------------------------------------------------------
export default function LeadMagnetModal({
  open,
  onClose,
  title,
}: LeadMagnetModalProps) {
  useEffect(() => {
    if (!open) {
      return;
    }
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative bg-white rounded-2xl w-full max-w-lg p-5 md:p-7 max-h-[90vh] overflow-y-auto">
        <button
          type="button"
          onClick={onClose}
          aria-label="Закрыть"
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
        <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4 pr-10">
          {title}
        </h3>
        <LeadMagnetForm />
      </div>
    </div>
  );
}